<script setup lang="ts">
import { computed } from 'vue';
import type { AmbassadorSignupStep } from '@/components/ambassador-signup/config/ambassador-signup-flow-config';

const props = defineProps<{ step: AmbassadorSignupStep }>();

const currentStepPercentage = computed(() => {
  switch (props.step) {
    case 'language':
      return 11;
    case 'email':
      return 22;
    case 'phone':
    case 'verification-phone':
      return 33;
    case 'name':
      return 44;
    case 'profile':
      return 55;
    case 'address':
      return 66;
    case 'actionsInterestedIn':
      return 77;
    case 'touchPoints':
      return 88;
    case 'resume':
      return 100;
    default:
      return 0;
  }
});
</script>

<template>
  <div class="bg-background-subtle w-full h-1">
    <div
      class="bg-background-brand-emphasis h-1 rounded-r-full transition-all duration-300 ease-in-out"
      :style="{ width: `${currentStepPercentage}%` }"
    ></div>
  </div>
</template>
